// Sorts a list of strings according to AP style guidelines. The list should be Titles for works (books, movies, etc.) and proper nouns.
export function sortTitlesAPStyle(a: string, b: string): number {
  // Helper function to normalize a string for AP style comparison
  const normalizeForAPStyle = (str: string): string => {
    let normalized = str.trim().toLowerCase();

    // Remove leading quotation marks
    normalized = normalized.replace(/^["']+/, '');

    // Remove leading "the " (including any remaining quotes before "the")
    normalized = normalized.replace(/^["']*the\s+/, '');

    return normalized;
  };

  const normalizedA = normalizeForAPStyle(a);
  const normalizedB = normalizeForAPStyle(b);

  // Standard alphabetical comparison
  if (normalizedA < normalizedB) return -1;
  if (normalizedA > normalizedB) return 1;
  return 0;
}
